import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import errorBoundary from '@ifeng/errorBoundary';
import Ad from '@ifeng/ui_pc_ad';
import Header from './header/';
import Content from './content/';
import Footer from './footerPart/';
import Totop from '../../../components/toTop/';
import { setWindowMode } from '../../../utils/responseWindow';
import styles from './index.css';

const Layout = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.object,
        };

        constructor(props) {
            super(props);

            this.state = {
                windowMode: setWindowMode(),
            };
        }

        componentDidMount() {
            // 上报首屏时间
            if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();

            window.onresize = () => {
                const currentMode = setWindowMode();

                this.setState({
                    windowMode: currentMode,
                });
            };
        }

        render() {
            const {
                content: {
                    nav,
                    adTop,
                    ad_rightRec_01,
                    ad_rightRec_02,
                    ad_rightRec_03,
                    ad_middle_banner,
                    ad_bottom_banner,
                    ad_slide,
                    ad_stream,
                    ad_hotNews,
                    ad_couplet,
                    ad_float,
                    ad_label,
                    search,
                    channelNav,
                    logo,
                    sportsBestPic,
                    rightPicRec,
                    rightRecTitlePic,
                    initTabSwitchData,
                    cooperation,
                    footer,
                    gq_pic,
                    bottom_videoPic,
                    bsInfoData,
                },
            } = this.props;

            const { windowMode } = this.state;

            const headerData = {
                nav,
                adTop,
                ad_label,
                search,
                channelNav,
                logo,
            };

            const contentData = {
                bsInfoData,
                sportsBestPic,
                rightPicRec,
                rightRecTitlePic,
                ad_slide,
                ad_rightRec_01,
                ad_rightRec_02,
                ad_rightRec_03,
                ad_stream,
                ad_hotNews,
                initTabSwitchData,
            };

            const footerData = {
                footer,
                cooperation,
                ad_middle_banner,
                ad_bottom_banner,
                gq_pic,
                bottom_videoPic,
            };

            return (
                <Fragment>
                    {/* 头部全站导航，广告，logo，搜索，频道导航 */}
                    <Header content={headerData} windowMode={windowMode} />
                    {/* 中间内容部部分 */}
                    <Content content={contentData} windowMode={windowMode} />
                    {/* 尾部合作链接、全站通用尾 */}
                    <Footer content={footerData} />
                    {/* 对联广告 */}
                    <div className={styles.ad_couplet}>
                        <Ad content={ad_couplet} />
                    </div>
                    {/* 浮动广告 */}
                    <div className={styles.ad_float}>
                        <Ad content={ad_float} />
                    </div>
                    <Totop windowMode={windowMode} />
                    <ChipEdit transform={transform} />
                </Fragment>
            );
        }
    },
);

export { Layout };
export default Layout;
